
import './App.css';
import Suggestion from './FeedbackFormScreen';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      < Suggestion /> 
      </header>
    </div>
  );
}

export default App;
